@if (!newBillingDesign) {
  <div class="row pad-bottom-20" id="payment-method-component">
    <div class="column twelve">
      @if (rows.length && (dataLoading | async) === false) {
        <ngx-datatable
          dsTableResizeWatcher
          #paymentMethodsTable
          class="none md-block"
          [ngClass]="cssClasses"
          [cssClasses]="{
            pagerLeftArrow: 'icon-chevron-left',
            pagerRightArrow: 'icon-chevron-right',
            pagerPrevious: 'icon-arrow-left-double',
            pagerNext: 'icon-arrow-right-double'
          }"
          [rows]="rows"
          [columns]="columns"
          [columnMode]="'force'"
          [headerHeight]="tableOnly ? 0 : 60"
          [rowHeight]="rowHeight"
          [selectionType]="''"
          [scrollbarH]="true"
          [limit]="5"
          [footerHeight]="footerHeight"
          (page)="onPageChanged()"
        >
        </ngx-datatable>
      }

      <ds-table
        class="block md-none"
        [rows]="rows"
        [columns]="columns"
        [headerHeight]="60"
        [tableClasses]="'action-row'"
      >
      </ds-table>

      <!-- The data has not come back yet -->
      @if (dataLoading | async) {
        <ds-localized-spinner
          class="block pad-bottom-20"
          [dataLoading]="dataLoading | async"
          [loadingMessage]="'Looking for payment methods...'"
        ></ds-localized-spinner>
      }

      @if (!tableOnly) {
        <div>
          <ds-add-payment-method-quicklinks-wrapper
            (addPaymentMethodEvent)="paymentMethodAddEditEvent($event)"
          ></ds-add-payment-method-quicklinks-wrapper>
          <ds-payment-method-modal
            [paymentMethodAddEditConfig]="paymentMethodAddEditConfig$ | async"
            [showTryAgainButton]="true"
            (paymentMethodAddEditCompleteEvent)="paymentMethodAddEditComplete($event)"
          >
          </ds-payment-method-modal>
        </div>
      }
    </div>
  </div>
}

<ng-template #headerCellTpl let-column="column">
  @if (!tableOnly && !!column) {
    <div class="header-cell table-header-cell-wrapper">
      <span
        [ngClass]="{
          'none lg-block': column?.name && column?.shortName,
          block: column?.name && !column?.shortName
        }"
        >{{ column?.name }}</span
      >
      @if (!!column?.shortName) {
        <span class="block lg-none">{{ column?.shortName }}</span>
      }
    </div>
  }
</ng-template>

<!-- Data Table - Method Details Cell Template -->
<ng-template #methodDetailsCellTpl let-row="row">
  <div class="method-details-cell ds-table-body-cell-header-wrapper">
    <!-- shown with ds-table -->
    @if (!!row) {
      <div
        class="ds-table-body-cell-header"
        [ngClass]="
          row?.paymentMethod?.expired || row?.paymentMethod?.expiring ? 'expired-expiring' : ''
        "
      >
        @if (!paymentMethodStandAloneEnabled) {
          <h3 class="margin-0" title="{{ row?.paymentMethod?.nickName }}">
            <span [ngClass]="row?.paymentMethod?.expired ? 'error-600-text' : ''">{{
              row?.paymentMethod?.nickName
            }}</span>
          </h3>
        }
        <div>
          @if (paymentMethodStandAloneEnabled) {
            <ds-payment-method-card
              class="cell-component"
              [rowExpanded]="expanded"
              [paymentAccount]="row.paymentMethod"
            >
            </ds-payment-method-card>
          }
        </div>
        @if (row?.paymentMethod?.expired || row?.paymentMethod?.expiring) {
          <div
            class="expired-expiring error-600-text"
            [ngClass]="paymentMethodStandAloneEnabled ? 'pad-left-45' : ''"
            data-cy="expiringMessage"
          >
            {{ row?.paymentMethod?.expired ? 'Expired' : 'Expires Soon' }}
          </div>
        }
      </div>
    }
    <!-- shown with full size ngx-data-table -->
    @if (!!row) {
      <div class="table-body-cell-label-content expandable-cell flex-column">
        <p class="margin-0" [ngClass]="row?.paymentMethod?.expired ? 'error-600-text' : ''">
          @if (!paymentMethodStandAloneEnabled) {
            <span class="h3" title="{{ row?.paymentMethod?.nickName }}">{{
              row?.paymentMethod?.nickName
            }}</span>
          }
        </p>
        <div>
          @if (paymentMethodStandAloneEnabled) {
            <ds-payment-method-card
              class="cell-component"
              [rowExpanded]="expanded"
              [paymentAccount]="row.paymentMethod"
            >
            </ds-payment-method-card>
          }
        </div>
        @if (row?.paymentMethod?.expired || row?.paymentMethod?.expiring) {
          <div
            class="expired-expiring error-600-text"
            [ngClass]="paymentMethodStandAloneEnabled ? 'pad-left-45' : ''"
            data-cy="expiringMessage"
          >
            {{ row?.paymentMethod?.expired ? 'Expired' : 'Expires Soon' }}
          </div>
        }
      </div>
    }
  </div>
</ng-template>

<!-- Data Table - Account Details Cell Template -->
<ng-template #accountDetailsCellTpl let-row="row" let-expanded="expanded">
  <div class="account-details-cell">
    @if (!!row) {
      <ds-payment-method-block
        class="cell-component"
        [rowExpanded]="expanded"
        [useNickNameAsTitle]="false"
        [paymentAccount]="row.paymentMethod"
      >
      </ds-payment-method-block>
    }
  </div>
</ng-template>

<!-- Data Table - Edit / Delete Action Cell Template -->
<ng-template #editCellTpl let-row="row" let-expanded="expanded" let-rowIndex="rowIndex">
  @if (!tableOnly && !!row) {
    <div class="edit-cell table-body-cell-label-content expandable-cell">
      <div class="flex md-none datatable-body-cell-label-actions">
        <!-- Mobile view - swap order -->
        <button
          ds-button
          authCheck
          [permissionName]="'editpaymentacct_walkthrough'"
          [checkAction]="'disable'"
          class="-outline-white margin-right-12"
          title="Edit this payment method"
          (click)="onEditEvent(row)"
        >
          @if (row?.paymentMethod?.expired) {
            <span>Update to use</span>
          } @else {
            <span>Edit</span>
          }
        </button>
        <a
          authCheck
          [permissionName]="'deletepaymentacct'"
          [checkAction]="'hide'"
          href="javascript:void(0);"
          class="error-600-text caption"
          title="Delete this payment method"
          (click)="onDeleteEvent(row)"
        >
          Delete
        </a>
      </div>
      @if (!expanded) {
        <div class="none md-flex datatable-body-cell-label-actions" data-cy="paymentMethodRow">
          <!-- Desktop view -->
          <a
            authCheck
            [permissionName]="'deletepaymentacct'"
            [checkAction]="'hide'"
            href="javascript:void(0);"
            class="error-600-text caption margin-right-8"
            title="Delete this payment method"
            (click)="onDeleteEvent(row)"
            data-cy="paymentMethodDeleteLink"
          >
            Delete
          </a>
          <button
            ds-button
            authCheck
            [permissionName]="'editpaymentacct_walkthrough'"
            [checkAction]="'disable'"
            class="-outline-white"
            title="Edit this payment method"
            (click)="onEditEvent(row)"
            data-cy="paymentMethodEditNavigationButton"
          >
            @if (row?.paymentMethod?.expired) {
              <span>Update to use</span>
            } @else {
              <span>Edit</span>
            }
          </button>
        </div>
      }
    </div>
  }
</ng-template>

@if (newBillingDesign) {
  @if (dataLoading | async) {
    <ds-localized-spinner
      class="block pad-bottom-20"
      [dataLoading]="dataLoading | async"
      [loadingMessage]="'Looking for payment methods...'"
    ></ds-localized-spinner>
  } @else {
    <div class="align-center grey-background">
      <div
        class="payment-methods-container"
        [ngClass]="{ 'display-saved-payments-only': displaySavedPayments }"
      >
        @if (!displaySavedPayments) {
          <div
            class="main-header font-weight-bold"
            dsContent
            [contentPath]="'billing.myPayMethods.header'"
          ></div>
        }
        @if (savedPaymentMethods.length) {
          @if (!displaySavedPayments) {
            <div
              class="sub-header font-weight-semibold font-size-1 margin-bottom-20"
              dsContent
              [contentPath]="'billing.myPayMethods.savedMethodsHeader'"
            ></div>
          }
          <div class="saved-methods-container">
            @for (savedPaymentMethod of savedPaymentMethods; track savedPaymentMethod) {
              <div class="tile row">
                <div class="method-info margin-right-16">
                  <div class="info-name font-size-1">{{ savedPaymentMethod.paymentMethod }}</div>
                  <div class="info-desc">{{ savedPaymentMethod.methodDesc }}</div>
                  @if (
                    savedPaymentMethod?.paymentAccount?.expired ||
                    savedPaymentMethod?.paymentAccount?.expiring
                  ) {
                    <div class="expired-expiring error-600-text" data-cy="expiringMessage">
                      {{ savedPaymentMethod?.paymentAccount?.expired ? 'Expired' : 'Expires Soon' }}
                    </div>
                  }
                </div>
                @if (!displaySavedPayments) {
                  <div
                    class="action-btn font-weight-semibold font-size-1"
                    (click)="onEditEvent(savedPaymentMethod.paymentAccount)"
                    dsContent
                    [contentPath]="'billing.myPayMethods.editMethod'"
                  ></div>
                }
              </div>
            }
          </div>
        }
        @if (!displaySavedPayments) {
          <div class="add-pay-method" (click)="addPaymentMethodModal()">
            <img class="margin-right-16" src="/assets/images/plus.svg" />
            <span
              class="font-size-1 font-weight-semibold"
              dsContent
              [contentPath]="'billing.addPayMethod'"
            ></span>
          </div>
        }
      </div>
    </div>
  }
}

<ds-modal
  id="addPaymentMethodModalId"
  [closeOthers]="true"
  maxWidth="702"
  [fullScreen]="true"
  [defaultCloseButton]="true"
>
  <ds-add-payment-method-quicklinks-wrapper
    (addPaymentMethodEvent)="paymentMethodAddEditEvent($event)"
    [newBillingDesign]="true"
  ></ds-add-payment-method-quicklinks-wrapper>
</ds-modal>

<div>
  <ds-payment-method-modal
    [paymentMethodAddEditConfig]="paymentMethodAddEditConfig$ | async"
    [showTryAgainButton]="true"
    (paymentMethodAddEditCompleteEvent)="paymentMethodAddEditComplete()"
  >
  </ds-payment-method-modal>
</div>
